import { Route, Routes } from "react-router-dom";

import UserCreateScreen from "screens/App/CRM/User/UserCreateScreen";
import UserDetailScreen from "screens/App/CRM/User/UserDetailScreen";
import UserEditScreen from "screens/App/CRM/User/UserEditScreen";
import UserListScreen from "screens/App/CRM/User/UserListScreen";
import UserChangePasswordScreen from "screens/App/CRM/User/UserChangePasswordScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const UserRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<UserListScreen />} />
      <Route path="create" element={<UserCreateScreen />} />
      <Route path=":id/detail" element={<UserDetailScreen />} />
      <Route path=":id/edit" element={<UserEditScreen />} />
      <Route
        path=":id/change-password"
        element={<UserChangePasswordScreen />}
      />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default UserRouter;
